import { Component, input, OnInit } from '@angular/core';
import { ProductListItemDto } from '../../../../dtos/product-list-item.dto';

import { ProductsPreviewComponent } from '../../../products-preview/products-preview.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cross-sell-products',
  templateUrl: './cross-sell-products.component.html',
  styleUrls: ['./cross-sell-products.component.scss'],
  imports: [ProductsPreviewComponent, TranslatePipe]
})
export class CrossSellProductsComponent implements OnInit {

  readonly products = input<ProductListItemDto[]>(undefined);

  constructor() { }

  ngOnInit() { }

}
